<template>
  <div class="reqular">
    <!-- start first step -->
    <div class="first-step" id="step_one">
      <div class="row game-card-wrapper">
        <div class="col-12 col-sm-6 col-md-4 game-card-col" v-for="(items,index) in gamePage" :key="items.id">
          <div class="game-card">
            <div class="card-game-holder">
              <div class="card-game-img">
                <img :src="items.img">
              </div>
              <div class="card-game-text">
                <p>{{ items.head }}</p>
                <p>{{ items.title }}</p>
                <div class="download" @click="downloadPDF(items.link)">
                  <p class="download">{{ items.download }}</p>
                  <i class="fas fa-download"></i>
                </div>
              </div>
              <div class="card-button">
                <div class="the-button">
                  <button @click="selectGame(items,index)" class="wro-button secondaryButtons"><span>Start Now</span>
                  </button>
                  <span class="skew-line-w"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end first step -->

    <!-- start first step -->
    <!--    <div class=" two-step" id="step_two" v-if="selectedGame">
          <q-breadcrumbs class="">
            <template v-slot:separator></template>
            <q-breadcrumbs-el style="color: black" :label="selected_head" icon="" @click="selectedGame = null"/>
            <q-breadcrumbs-el label="Levels" icon="fas fa-chevron-right"/>
          </q-breadcrumbs>
          <div class="row game-card-wrapper">
            <div class="col-12 col-sm-6 game-card-col" v-for="(sub_items,index) in selectedGame" :key="sub_items.id">
              <div class="game-card">
                <div class="card-game-holder">
                  <div class="card-game-img">
                    <img :src="sub_items.img">
                  </div>
                  <div class="card-game-text">
                    <p>{{ sub_items.head }}</p>
                    &lt;!&ndash;                <p>{{ sub_items.title }}</p>&ndash;&gt;
                  </div>
                  <div class="card-button">
                    <div class="the-button">
                      <button @click="selectLevel(sub_items,index)" class="wro-button secondaryButtons">
                        <span>Start Now</span>
                      </button>
                      <span class="skew-line-w"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <!-- end first step -->
  </div>
</template>


<script>
import ButtonComponent from "@/components/tools/ButtonComponent";

export default {
  props: ['userAge','userData'],
  data: () => ({
    filteredGame: [
      {
        head: 'elmentary',
        title: 'The robot is required to perform several tasks required to raise the efficiency of the house. Electricity production and consumption will be managed as the robot performs the required tasks at home. The house consists of three levels. The ground floor is the garage, a living space on the first floor, and the roof which holds the solar cells required to provide electricity. For more details, please read the game guide.',
        img: require('@/assets/img/user/gamePlay/elementary.jpeg'),
        download: 'Download Virtual Regular Elementary Game Guide',
        link: 'https://wro-v.com/backend/pdf/elementary.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
            download: 'Download Virtual Regular Senior Game Guide',
            link: 'https://wro-v.com/backend/pdf/elementary.pdf',
          },
        ],
        mission: 0
      },
      {
        head: 'junior',
        title: 'Your package delivery robot moves in a town environment divided into several zones. It is required to move packages to their required destinations with the same color. At the same time, It consumes energy as it moves or carries the packages. There are several energy power stations located in the field for the robot to recharge its battery and continue solving the missions. For more details, please read the game guide.',
        img: require('@/assets/img/user/gamePlay/junior.jpeg'),
        download: 'Download Virtual Regular Junior Game Guide',
        link: 'https://wro-v.com/backend/pdf/junior.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
          },
        ],
        mission: 1
      },
      {
        head: 'senior',
        title: 'In this mission, this maintenance robot is responsible for delivering repair kits to the power stations of different three different types; Solar energy, Wind energy, and Hydroelectric energy. Some of the destinations are openly available while others are closed. You are required to deliver the kits to the open destinations in order for the closed ones to open. For more details, please read the game guide',
        img: require('@/assets/img/user/gamePlay/senior.jpeg'),
        download: 'Download Virtual Regular Senior Game Guide',
        link: 'https://wro-v.com/backend/pdf/senior.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
          },
        ],
        mission: 2,
      },

    ],
    selectedGame: null,
    selected_head: null,
    mission: '',
    level: '',
    organizer_id: null,
    gamePage: []
  }),
  components: {ButtonComponent},
  mounted() {
    if (this.userAge.length == 4) {
      this.gamePage = this.filteredGame
    } else {
      this.gamePage = this.filteredGame.filter(el => el.head == this.userAge[0].name)
    }
    this.organizer_id = this.$store.state.InternalSettings[0].organizer_id;


    if(this.userAge[0].name === 'junior') {
      this.mission = 1;
    }

    if(this.userAge[0].name === 'elmentary') {
      this.mission = 0;
    }

    if(this.userAge[0].name === 'senior') {
      this.mission = 2;
    }


  },
  methods: {
    selectGame(items) {

      // set mission index
      $cookies.set('mission', items.mission);


      $cookies.set('robot_name', this.userData.robot_name);
      $cookies.set('rolot_color', this.userData.rolot_color);

      /*let game = document.getElementById('step_one');
      let level = document.getElementById('step_two');

      // hide choose game
      game.style.display = "none";

      // show game levels
      level.style.display = "block";*/
      this.selectedGame = items.sub;
      this.selected_head = items.head;

      /* Select level from here */
      // set level
      this.level = items.mission;
      $cookies.set('level', this.level);
      // user id
      $cookies.set('id', this.$store.state.userData.id);
      // redirect to game play
      window.location.href = `https://wro-v.com/backend/api/admin/robot01?organizer_id=${this.organizer_id}&id=${this.$store.state.userData.id}&mission=${items.mission}&level=1&robot_name=${this.userData.robot_name}&robot_color=${encodeURIComponent(this.userData.robot_color)}`;

    },
    selectLevel(sub_items) {
      // set level
      this.level = this.mission;
      $cookies.set('level', this.level);
      // user id
      $cookies.set('id', this.$store.state.userData.id);
      // redirect to game play
      window.location.href = `https://wro-v.com/backend/api/admin/robot01?organizer_id=${this.organizer_id}&id=${this.$store.state.userData.id}&mission=${this.mission}&level=${this.level}`;
    },
    downloadPDF(fileURL) {
      window.open(fileURL);
    }
  }
}
</script>